<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ログアウトの確認</span>
        </div>
        <div class="popup-content">
          <p class="txt">ログアウトしてもよろしいですか？</p>
          <div class="button">
            <button class="btn" type="submit" @click="group1.logout">ログアウト</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicLogout from '@/logic/Logout'

export default defineComponent({
  name: 'PCLogoutConfirm',
  setup (props, context) {

    const group1 = logicLogout.getGroup(props, context)

    const close = () => {
      context.emit('closeLogout')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  .button .btn {
    width: 230px;
    margin: 0 auto;
  }
}
</style>
